"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.local = void 0;
const default_1 = require("../config/default");
exports.local = {
    ...default_1.defaultConfig,
    endpoints: {
        ...default_1.defaultConfig.endpoints,
        graphqlUseSSL: false,
        graphqlHost: "192.168.5.20:3000",
    },
};
//# sourceMappingURL=local.js.map